import type { QueryClient } from '@tanstack/react-query';

/** A ledger correction affects both sale cohorts and collection-date reports. */
export async function refreshSaleConsumers(client: QueryClient) {
  const roots = [
    'deliveries',
    'delivery',
    'delivery_share',
    'delivery_contract',
    'sales',
    'purchases',
    'inventory',
    'stock_entry_choices',
    'products',
    'catalog_profile',
    'catalog_versions',
    'catalog_choices',
    'jersey_identifiers',
    'product_types',
    'operations_contract',
    'variants',
    'cash_accounts',
    'cash_transactions',
    'voided_cash_transactions',
    'cashbook',
    'accounts_summary',
    'accounts',
    'dashboard_kpis',
    'recent_sales',
    'sales_analytics',
    'sales_contribution',
    'sales_contribution_orders',
    'sale_whatsapp',
    'sale_share_settings',
    'org_profiles',
    'staff_members',
    'report',
    'sale_tracking',
    'audit_logs',
    'recycle_bin',
    'recycle_job',
    'deactivated_products',
    'import_batches',
  ];
  await Promise.all(roots.map((root) => client.invalidateQueries({ queryKey: [root] })));
}
